var React = require('react');

function Rss (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M-271,360v48.9c31.9,0,62.1,12.6,84.7,35.2c22.6,22.6,35.1,52.8,35.1,84.8v0.1h49.1c0-46.6-19-88.7-49.6-119.4\r\n\t\tC-182.2,379-224.4,360.1-271,360z","key":0}),React.createElement("path",{"d":"M-237,460.9c-9.4,0-17.8,3.8-24,10s-10,14.6-10,24c0,9.3,3.8,17.7,10,23.9c6.2,6.1,14.6,9.9,24,9.9s17.8-3.7,24-9.9\r\n\t\ts10-14.6,10-23.9c0-9.4-3.8-17.8-10-24C-219.2,464.7-227.6,460.9-237,460.9z","key":1}),React.createElement("path",{"d":"M-90.1,348.1c-46.3-46.4-110.2-75.1-180.8-75.1v48.9C-156.8,322-64.1,414.9-64,529h49C-15,458.4-43.7,394.5-90.1,348.1z","key":2})]));
}

Rss.defaultProps = {"height":"14","width":"14","version":"1.1","id":"Layer_1","viewBox":"-271 273 256 256","xmlSpace":"preserve"};

module.exports = Rss;

Rss.default = Rss;
